import * as React from 'react';
const SvgMailIcon = () => (
  <svg
    width={24}
    height={20}
    style={{ width: 24, height: 20 }}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x={1} y={1} width={22} height={18} rx={1} stroke="#5A5A87" strokeWidth={2} />
    <path d="M1 4L12 9.5L23 4" stroke="#5A5A87" strokeWidth={2} />
  </svg>
);
export default SvgMailIcon;
